module.exports = __webpack_public_path__ + "8250310a5bfe319e2c1be13fb222997b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/unimpressed-4.png
// module id = 2367
// module chunks = 0